import dayjs from 'dayjs';

export const notificationSentAtFormattedDate = (iso?: string | null) => {
  if (!iso) return '-';

  const d = new Date(iso);

  if (Number.isNaN(d.getTime())) return iso;

  return new Intl.DateTimeFormat(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(d);
};

/** A visit's span, as every notification surface prints it. */
export const formatVisitRange = (startISO?: string, endISO?: string) => {
  if (!startISO && !endISO) return '';

  const toLocal = (iso: string) => dayjs(iso);
  const fmtDate = (d: dayjs.Dayjs) => d.format('DD/MM/YYYY');
  const fmtTime = (d: dayjs.Dayjs) => d.format('HH:mm');

  if (startISO && endISO) {
    const s = toLocal(startISO);
    const e = toLocal(endISO);

    return s.isSame(e, 'day')
      ? `${fmtDate(s)} at ${fmtTime(s)} → ${fmtTime(e)}`
      : `${fmtDate(s)} at ${fmtTime(s)} → ${fmtDate(e)} at ${fmtTime(e)}`;
  }

  const one = toLocal((startISO ?? endISO)!);
  return `${fmtDate(one)} at ${fmtTime(one)}`;
};

export const isValidDate = (dateString: string) => {
  const d = new Date(dateString);
  return !isNaN(d.getTime());
};
